import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";  // Import getAuth for authentication
import { getFirestore } from "firebase/firestore";  // Import Firestore for db
import { getStorage } from "firebase/storage";  // Optional, if you're using storage

const firebaseConfig = {
  apiKey: "AIzaSyAK3VIq0SzRam9ucG9K2AhMmx69B73cbBI",
  authDomain: "ranathunga-optical.firebaseapp.com",
  projectId: "ranathunga-optical",
  storageBucket: "ranathunga-optical.firebasestorage.app",
  messagingSenderId: "518930739902",
  appId: "1:518930739902:web:f52dc1b952a5eda87224ef"
};


const app = initializeApp(firebaseConfig);

const auth = getAuth(app);  // Initialize Firebase Authentication
const db = getFirestore(app);  // Initialize Firestore
const storage = getStorage(app);  // Initialize Firebase Storage (if needed)

export { auth, db, storage };